import { useState, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom"
import { WisrOptionService } from "../../../service/wisrOptions";
import AppContextObject from "../../../common/context/common";
import DataContext from "../../../service/brandContext";
import { titleCase } from "../../../service/helper";
import Pagination from "../../../components/addon/pagination";

const SchoolImpressionDetail = ({setShowSidemenu}) => {
  const topRef = useRef()
  const location = useLocation()
  const [schoolList, setSchoolList] = useState([])
  const context = useContext(AppContextObject);
  const [isPageLoading, setIsPageLoading] = useState(false)
  // const [prevCount, setPrevCount] = useState(500)
  const [perPageCount, setPerPageCount] = useState({1: 500})
  const [currentPage, setCurrentpage] = useState(1)
  const [totalPage, setTotalPage] = useState([0])
  const [sortingData, setSortingData] = useState({schoolName: 1})
  // const [optimisedSchoolLength, setOptimisedSchoolLength] = useState(500)

  useEffect(() => {
    setShowSidemenu(false)
  }, [])
  useEffect(() => {
    getAllSchoolList();
    // let ref:any = topRef
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [currentPage]);

  const getAllSchoolList = async () => {
    setIsPageLoading(true)
    // let schoolTypeArray = filterBySchoolType.length === 0 ? [] : filterBySchoolType.length === 1 ? [...filterBySchoolType] : ["co-ed"]
    let city = []
    const param = new URLSearchParams(location.search).getAll('city')
    const filterParam = new URLSearchParams(location.search).get('filter')
    city = [...param]
    const resp = await context.apis.public.getAllSchools(
      context.validator, {city: [...city]}, { limit: 3000, page: currentPage, withCount: true, sort: sortingData }
    )
    if (resp && resp.done) {
      console.log("getAllSchools", resp)
      let inventoryName = [], eventName = [], classRoomList = [], schoolsList = [], inventoryList = [], eventList = [], OptimizedSchool = []
      resp.response.rows.forEach(item => {
        classRoomList = [...classRoomList, ...item.classrooms]
        inventoryList = [...inventoryList, ...item.inventories.filter(inventory => inventory.status !=="Unavailable" && inventory.isApproved !== false)]
        eventList = [...eventList, ...item.activities.filter(event => event.status !=="Unavailable" && event.isApproved !== false)]
        schoolsList.push(item)
      })
      inventoryList.forEach(item => {
        if (!inventoryName.includes(item.parentName)) {
          inventoryName.push(item.parentName)
        }
      })
      eventList.forEach(item => {
        if (!eventName.includes(item.name)) {
          eventName.push(item.name)
        }
      })
      const WisrOption = new WisrOptionService({
        TargetAudience: "co-ed",
        EventsNames: [...eventName],
        InventoriesNames: [...inventoryName],
        budgetRatio: { CatA: 0, CatB: 0, CatC: 0 },
        campaignBudget: 0,
        campaignDurationInDays: 365,
        classroomData: classRoomList, //List of classrooms
        eventData: eventList, //List of events
        inventoryData: inventoryList, //List of inventories
        schoolData: schoolsList, //List of schools
        noOfDaysInYear: 365,
        percentageDiscountInWISR: 0,
        percentageIncreaseInReach: 0,
        totalInternalCostPerSchool: 14180.3,
      });
      WisrOption.$OptimizedSchool.subscribe((school) => {
        OptimizedSchool = [...school]
        console.log("OptimizedSchool", school)
        if(filterParam === "true"){
          let otherSchools =["A.B. V.N. School","A.B.M.H Hr Sec School","Achiever \" S Public School","AKIN CHILDREN PUBLIC SCHOOL","ALIENS CONVENT SCHOOL","Alpine Convent School ","Amardeep  Hr sec  School ","Anand  Vidhya Mandir ","apple kids h.s school","Aqua test school","B.R. Memorial JR. High school","Birdies foundation school","BOSTON PUBLIC SCHOOL","Central Modern School","CHETNA PUBLIC INTER COLEGE-2","Chitra inter college ","Christ Memoriyal School ","City Convent School","Devgun Convent Sr.Sec.School","disha convent school","Disha Convent School","DOLLY PUBLIC SHOOL","DPSS' Sandesh Vidyalaya Prathmik and Purva Prathmik (Parksite)","Dr K P Sonkar High School","DVS High School Marathi","ERA MODEL SCHOOL","ESS ESS CONVENT SCHOOL","ESS ESS PUBLIC SCHOOL","Events  Convent  School","Felix Public Hr Sec School","First Step School","G.B. convent hr. sec. school","geetanjali public school","Golden Birds Publick Hr Sec School","GOVIND SAVITRI BAAI FULE KANYA INTER COLLEGE","Green rose senior secondary school","GURUKULAM WORLD SCHOOL","Holy heart convent hr. sec. school","Icon International public school","IMPACT GIRL INTER COLLEGE","Indian English School","jagrati hr.sec.School ","Karamveer Bhaurao Patil English Primary School","KIDS VANASTHALI SCHOOL","M.A Ideal High School","M.D. PUBLIC SCHOOL","MAA BAUKUNTI DEVI SARVODHYA INTER COLLEGE","Maharshi Arvind Vidya Niketan","MAHENDRA SINGH INTER COLLEGE","MARIA MEMORIAL HIGH SCHOOL","Mary kids school","Marydoll Publick  school","Moolchand Chauhan Public High School","My World School ","Nav Saraswati Inter College","New Angels Convent school","New Bombay City School","NEW ST.CARNED INTER COLLEGE","O Grove Public school","p.p.n memorial school","Pandit Jawaharlal Nehru Hindi Vidyalay","Piyari Devi Inter Collage","Prakash vidya mandir inter college ","Pupil glossy convent school","Raja Ram Vidya Vihar","RAM KISHORE CONVENT INTER COLLAGE","Rising Bud care academy","Roseal publick School ","SACRED MOTHER'S JUNIOR SCHOOL","Samruddhi Hindi Prathmik vidyalay, Tagore Nagar","Sandesh College of Commerce, Suryanagar","Sandesh Vidyalaya High School (English), Tagore Nagar","Sant Buddharam Inter Collage","Saraswati co.ed. pubilc school","Saraswati Shishu Mandir school","Satyam convent H.s.school","Scholars play ways inter college","Scholers English Academy","Shanti Shiksha Niketan","Shine Model School","shri balaji education centre ","SHRI BALAJI GIRLS INTER COLLEGE","Shri Jee Sanskar Public School ","Shri Krishna International Public School","SHRI RAJDEV PUBLIC INTER COLLEGE","SMT.GAYATRI DEVI GIRLS INTER COLLEGE","Sophia High School","SPAI College","St Marks English school","ST.B.M.L.L GIRLS INTER COLLEGE","St.Mount Convent School","St.Saviour Publick Hr Sec School","St.Stephen,s Hr Sec School","Suman Saurabh H.S School","Sun Glow English School","Sun Grace Convent School, Mankurdh","Sunrise English Preprimary and Primary School, Parksite","SWAMI VIVEKANAND BAL VIDYAMANDIR IC","the national convebt jr high school","U.R. Bajpai Memorial Scholars Valley","Vijay Laxmi S.S. School","Vishwa bharti gyan niketan g. inter college ","Vivekanand shicha Niketan ","Zenith Academy"]
          let newSchools = school.filter(item => !otherSchools.includes(item.schoolName))
          setSchoolList([...newSchools])
          // setSchoolList([...school])
          // setPerPageCount({...perPageCount, [currentPage]: school.length})
          // setOptimisedSchoolLength(school.length)
        }
        else{
          let nonOptimisedSchools = resp.response.rows.filter(item => !school.find(data => data.schoolName === item.schoolName))
          setSchoolList([...school, ...nonOptimisedSchools])
          // setPerPageCount({...perPageCount, [currentPage]: 500})
          // setOptimisedSchoolLength(500)
        } 
      })
      // schoolsList = resp.response.rows.map(item => {
      //   let found = OptimizedSchool.find(data => data._id === item._id)
      //   if (found) {
      //     item["impression"] = found.impressions
      //   }
      //   return item
      // })
      // console.log("schoolsList", schoolsList)
      // setSchoolList([...schoolsList])
      let total = Math.ceil(Number(resp.response.count) / (currentPage === 1 ? 500 : perPageCount[currentPage - 1]))
      let arr = []
      for (let i = 0; i < total; i++) {
        arr.push(i)
      }
      setTotalPage([...arr])
      setIsPageLoading(false)
    }
    setIsPageLoading(false)
  }
  const onPageChange = (page) => {
    setCurrentpage(page)
  }
  const onNextClick = () => {
    setCurrentpage(prev => prev + 1)
  }
  const onPrevClick = () => {
    setCurrentpage(prev => prev - 1)
  }
  return (
    <>
      <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mb-20 pl pr">
        <div className="table-container mt-10 addAdmininput fillterTableHeight">
          <table className="table going-campaign tableSpacingtd">
            <thead >
              <tr ref={topRef}>
                <th>SR No</th>
                <th>School Name</th>
                <th>State</th>
                <th>City</th>
                <th>Category</th>
                <th>reach</th>
                <th>Total Brand outlay</th>
                <th>Total impressions </th>
                <th>Inventory Details</th>
                <th>Event Details</th>
              </tr>
            </thead>
            <tbody>
              {/* <tr>
                <td colSpan={10}></td>
              </tr> */}
              {!isPageLoading ?
                schoolList.length !== 0 ? schoolList.map((data: any, index) => {
                  return (
                    <tr key={index}>
                      <td>{((currentPage - 1) * (currentPage === 1 ? 500 : perPageCount[currentPage - 1])) + (index + 1)}</td>
                      <td>
                        <h4>{data.schoolName && titleCase(data.schoolName)}</h4>
                      </td>
                      <td>{titleCase(data.state)}</td>
                      <td>{titleCase(data.city)}</td>
                      <td>{data.category}</td>
                      <td>{data.reach || 0}</td>
                      <td>{data.totalBrandOutlay || 0}</td>
                      <td>{data.impressions !== undefined && data.impressions !== null ? data.impressions : "-"}</td>
                      <td>
                        <table>
                          
                            {data.inventories && data.inventories.map((inventory, index) => (
                                <>
                                  {index ===0  &&
                                  <thead>
                                    <th>Name</th>
                                    <th>Impressions</th>
                                    <th>Brand outlay</th>
                                  </thead>
                                  }
                                  <tbody>
                                    <tr>
                                      <td>{titleCase(inventory.name)}</td>
                                      <td>
                                        {inventory.attributes && inventory.attributes.length > 0 && inventory.attributes.reduce((acc, current, index) => {
                                          acc += (current.impressions || 0)
                                          return Math.round(acc)
                                        }, 0) || "-"}
                                      </td>
                                      <td>
                                        {inventory.attributes && inventory.attributes.length > 0 && inventory.attributes.reduce((acc, current, index) => {
                                          acc += (current.brandOutlayByDuration || 0)
                                          return Math.round(acc)
                                        }, 0) || "-"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </>
                            ))}
                        </table>
                      </td>
                      <td>
                        <table>
                          
                            {data.events && data.events.map((event, index) => (
                              <>
                                {index === 0 && 
                                  <thead>
                                    <th>Name</th>
                                    <th>Impressions</th>
                                    <th>Brand outlay</th>
                                  </thead>
                                }
                                <tbody>
                                  <tr>
                                    <td>{titleCase(event.name)}</td>
                                    <td>
                                      {event.attributes.reduce((acc, current, index) => {
                                        acc += (current.impressions || 0)
                                        return Math.round(acc)
                                      }, 0) || "-"}
                                    </td>
                                    <td>
                                      {event.attributes.reduce((acc, current, index) => {
                                        acc += (current.brandOutlayByDuration || 0)
                                        return Math.round(acc)
                                      }, 0) || "-"}
                                    </td>
                                  </tr>
                                </tbody>
                              </>
                            ))}
                          
                        </table>
                      </td>
                    </tr>
                  )
                })
                  :
                  <tr><td colSpan={10}>No School found</td></tr>
                :
                [...Array(10)].map((el, index) => {
                  return (
                    <tr key={index}>
                      {
                        [...Array(10)].map((el, index) => {
                          return (
                            <td key={index}>
                              <div className="content-loader-block"></div>
                            </td>
                          )
                        })
                      }
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        {/* {totalPage.length > 1 &&
          <Pagination
            currentPage={currentPage}
            totalPage={totalPage}
            onPageChange={onPageChange}
            onNextClick={onNextClick}
            onPrevClick={onPrevClick}
            loading={isPageLoading}
          />
        } */}
      </div>
    </>
  )
}

export default SchoolImpressionDetail;
